// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import uploader from 'vue-simple-uploader';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './util/filter';
import router from './router';
import quill from './util/quill/quill';
import store from './store/store';// 状态管理
import Message from './components/common/message';
import './assets/styles/root.css';
import App from './App';

Vue.use(ElementUI);
Vue.use(uploader);
Vue.use(Message);
Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>',
});



// WEBPACK FOOTER //
// ./src/main.js